import { Icon, ICONS } from '@creditsights/styleguide-web';
import React, { ReactElement } from 'react';

interface WatchlistAlertProps {
  isAnyAlertSelected: boolean;
}

const WatchlistAlert = (props: WatchlistAlertProps): ReactElement => {
  const { isAnyAlertSelected } = props;

  return isAnyAlertSelected ? (
    <Icon name={ICONS.BellFull} dataTestId="watchlist-alert-bell-full-icon" />
  ) : (
    <Icon name={ICONS.Bell} dataTestId="watchlist-alert-bell-icon" />
  );
};

export default WatchlistAlert;
